if (!customElements.get('custom-modal-opener')) {
  customElements.define(
    'custom-modal-opener',
    class CustomModalOpener extends HTMLElement {
      constructor() {
        super();
    
        const button = this.querySelector('a');
    
        if (!button) return;
        button.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(button);
        });
      }
    }
  );
}
if (!customElements.get('custom-popup-modal')) {
  customElements.define(
    'custom-popup-modal',
    class CustomPopupModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="custom-popup-info-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
         super.show(opener);
      }
    }
  );
}
